import { faChartColumn, faCheckCircle, faFolder, faPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Process = () => {
  const steps = [
    {
      number: "01",
      title: "Assessment",
      description: "Complete our comprehensive assessment form and receive personalized visa recommendations",
      icon: faChartColumn,
      gradient: "from-blue-500 to-cyan-500",
    },
    {
      number: "02",
      title: "Document Collection",
      description: "Our experts guide you through document requirements and verification process",
      icon: faFolder,
      gradient: "from-purple-500 to-blue-500",
    },
    {
      number: "03",
      title: "Application Submission",
      description: "We prepare and submit your application with all required authorities",
      icon: faPlane,
      gradient: "from-green-500 to-cyan-500",
    },
    {
      number: "04",
      title: "Visa Approval",
      description: "Receive your visa and comprehensive travel preparation guidance",
      icon: faCheckCircle,
      gradient: "from-orange-500 to-red-500",
    }
  ];

  return (
    <section id="process" className="py-20 bg-gradient-to-br from-slate-50 to-blue-50 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-400 to-transparent"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-20" data-aos="zoom-in"> 
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 text-blue-600 text-sm font-medium mb-4">
            <span className="w-2 h-2 bg-blue-600 rounded-full mr-2 animate-pulse"></span>
            How It Works
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4 bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
            Simple 4-Step Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            From assessment to approval, we guide you through every step with transparency and expertise
          </p>
        </div>
        
        {/* Process Timeline */}
        <div className="relative">
          {/* Connecting Line */}
          <div className="hidden lg:block absolute top-24 left-1/2 transform -translate-x-1/2 w-3/4 h-1 bg-gradient-to-r from-blue-200 to-cyan-200 rounded-full"></div>
          
          <div className="grid lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative group" >
                {/* Step Card */}
                <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 relative z-10" data-aos="fade-right">
                  {/* Step Number */}
                  <div className={`absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br ${step.gradient} rounded-2xl flex items-center justify-center text-white font-bold text-lg shadow-lg`}>
                    {step.number}
                  </div>
                  
                  {/* Icon */}
                  <div className={`w-20 h-20 bg-gradient-to-br ${step.gradient} rounded-2xl flex items-center justify-center text-white text-3xl mb-6 mx-auto transform group-hover:scale-110 transition-transform duration-500 shadow-lg`}>
                    <FontAwesomeIcon icon={step.icon}/>
                  </div>
                  
                  {/* Content */}
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center group-hover:text-blue-600 transition-colors duration-300">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-6 text-center">
                    {step.description}
                  </p>
                  
              
                </div>
                
                {/* Mobile Connecting Line */}
                <div className="lg:hidden absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 w-8 h-1 bg-blue-200 rounded-full"></div>
              </div>
            ))}
          </div>
        </div>
        
  
        
      </div>
    </section>
  );
};

export default Process;